import ownerPlans from './plans-new';
import socialAIPlans from './social-ai-plans';

// Owners should continue to see the old plans *for now* because they
// continue to sign people up to them (!!?)
const plans = process.env.REACT_APP_IS_OWNER === 'true' ? ownerPlans : socialAIPlans;

export default plans;
